module.exports = "/assets/data/532afa5fee4f644a5a93d07e832d4f09-TN40.data.json";